import { useTranslation } from "react-i18next";
import { Button } from "@tellescope/design-system";
import { AlertCircle } from "lucide-react";

interface FormResponseErrorProps {
  onRetry: () => void;
  onClose: () => void;
}

export const FormResponseError = ({ onRetry, onClose }: FormResponseErrorProps) => {
  const { t } = useTranslation("forms");

  return (
    <div className="flex-1 flex items-center justify-center p-8">
      <div className="text-center space-y-4">
        <AlertCircle className="h-8 w-8 mx-auto text-destructive" />
        <div className="space-y-1">
          <p className="text-sm font-medium">{t("This form could not be loaded")}</p>
          <p className="text-sm text-muted-foreground">{t("Your previous answers were saved.")}</p>
        </div>
        <div className="flex items-center justify-center gap-2">
          <Button variant="outline" size="sm" onClick={onClose}>
            {t("Close")}
          </Button>
          <Button size="sm" onClick={onRetry}>
            {t("Try again")}
          </Button>
        </div>
      </div>
    </div>
  );
};
